import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import "./colorThemeCard.css";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,ChevronRight,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';

const ColorThemeBarCard =({themeText,themeSubText,fontFamily,bgColor,activeCardBorder,textIconBG,primaryColor,textIconPrimary,
  buttonColor,textIconButton,activeCard,onClickPopup})=>{

    
     const dispatch = useDispatch();
     
      
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
     
      const activeCardBorderIn =activeCard?"4px solid #90CAF9":"4px solid #fff";
       const activeCardBorderStyle={border:activeCardBorderIn,padding:"0px",margin:"0px"}
      const bgColorStyle={background:bgColor,border:activeCardBorder,paddingTop:"10px",
          fontFamily:fontFamily,color:textIconBG
      }
      const textIconBGStyle={color:textIconBG,padding:"0px",margin:"0px",borderRadius:"50%"}
      const primaryColorStyle={background:primaryColor,padding:"0px",margin:"0px"}
      const textIconPrimaryStyle={color:textIconPrimary,padding:"0px",margin:"0px",height:"35px"}
      const buttonColorStyle={background:buttonColor,padding:"0px",margin:"0px"}
      const textIconButtonStyle={color:textIconButton,padding:"0px",margin:"0px",height:"35px"}
     
      return (<>
        <div     onClick={()=>onClickPopup()}  className="itemColorThemeBarCard"
 style={activeCardBorderStyle}> {activeCard?<div className="activeColorBarCardIcon"><Check size={20}  color={"#fff"} /></div>:""}
<div><div  onMouseEnter={()=>handleMouseEnter("#fff","#333","Background Color")}
onMouseLeave={handleMouseLeave} style={bgColorStyle}><div style={{fontSize:"24px",fontWeight:"bold"}}><div style={textIconBGStyle}      >Aa</div></div>
</div>
<div  onMouseEnter={()=>handleMouseEnter("#fff","#333","Primary Color")}
onMouseLeave={handleMouseLeave}  style={primaryColorStyle}><div style={{fontSize:"24px",fontWeight:"bold"}}><div    style={textIconPrimaryStyle} >Aa</div></div>
</div></div>
<div  onMouseEnter={()=>handleMouseEnter("#fff","#333","Buttons Color")}
onMouseLeave={handleMouseLeave} style={buttonColorStyle}  ><div style={{fontSize:"24px",fontWeight:"bold",alignItems:"center",paddingTop:"20px"}} ><div style={textIconButtonStyle} >Aa</div></div>
</div>


{/* <div style={textIconBGStyle}></div> */}

 


   </div></>)
}
export default ColorThemeBarCard;

